// Authentic imagery: Unsplash/Pexels destination & vehicle photos + one generated
// Tempo Traveller shot. Keep alt text descriptive at point of use.

export const IMG = {
  heroHighway:
    "https://images.unsplash.com/photo-1601920791548-bd0a29f848c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBoaWdod2F5JTIwcm9hZCUyMHRyaXAlMjBtb3VudGFpbnN8ZW58MHx8fHwxNzkwOTY4MzQzfDA&ixlib=rb-4.1.0&q=85&w=2000",
  outstation:
    "https://images.unsplash.com/photo-1611146848953-180a29a42427?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxpbmRpYW4lMjBoaWdod2F5JTIwcm9hZCUyMHRyaXAlMjBtb3VudGFpbnN8ZW58MHx8fHwxNzkwOTY4MzQzfDA&ixlib=rb-4.1.0&q=85&w=1400",
  forestRoad:
    "https://images.unsplash.com/photo-1626002547082-f12bc6b7a72b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBoaWdod2F5JTIwcm9hZCUyMHRyaXAlMjBtb3VudGFpbnN8ZW58MHx8fHwxNzkwOTY4MzQzfDA&ixlib=rb-4.1.0&q=85&w=1400",
  sedan:
    "https://images.unsplash.com/photo-1714502524998-e8ea4dd3781d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHx3aGl0ZSUyMHNlZGFuJTIwdGF4aSUyMGNhciUyMGluZGlhfGVufDB8fHx8MTc5MDk2ODM0M3ww&ixlib=rb-4.1.0&q=85&w=1200",
  innova:
    "https://images.unsplash.com/photo-1748215210950-536c6621629a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwyfHx0b3lvdGElMjBpbm5vdmElMjB3aGl0ZSUyMHN1dnxlbnwwfHx8fDE3OTA5NjgzNDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
  mpv:
    "https://images.unsplash.com/photo-1748215210939-ad8b6c8c086d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwxfHx0b3lvdGElMjBpbm5vdmElMjB3aGl0ZSUyMHN1dnxlbnwwfHx8fDE3OTA5NjgzNDN8MA&ixlib=rb-4.1.0&q=85&w=1200",
  tempo:
    "https://static.prod-images.emergentagent.com/jobs/68efabdb-87c7-4177-8db1-123eba4cb9aa/images/db882d1cb15ac48ed219e575ea2cfab411d85a0f5b40fe9229d82658da2be608.jpeg",
  heroFleet:
    "https://static.prod-images.emergentagent.com/jobs/68efabdb-87c7-4177-8db1-123eba4cb9aa/images/906ae04f3aa59fd9d30d8ab32670c86b0f0421ddf077c41b50bcef4cbe9e3970.jpeg",
  carSedan:
    "https://static.prod-images.emergentagent.com/jobs/68efabdb-87c7-4177-8db1-123eba4cb9aa/images/747bcd72d2f4d273ec9b341792cd18ad0db69d30a26bdb0381bca4d9735c82f7.jpeg",
  carSuv:
    "https://static.prod-images.emergentagent.com/jobs/68efabdb-87c7-4177-8db1-123eba4cb9aa/images/6c9326b00a5d7194c2e4b5a4e4496e386982435b9a00a3e4660a7318ff30395f.jpeg",
  carPremium:
    "https://static.prod-images.emergentagent.com/jobs/68efabdb-87c7-4177-8db1-123eba4cb9aa/images/8f3d161e66ebf44cf14b6ac3e2147ca7880aa8a45d67274a4628c6ac500ed15d.jpeg",
  khajuraho:
    "https://images.unsplash.com/photo-1606298855672-3efb63017be8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwxfHxraGFqdXJhaG8lMjB0ZW1wbGUlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkwOTY4MzQzfDA&ixlib=rb-4.1.0&q=85&w=1400",
  khajuraho2:
    "https://images.unsplash.com/photo-1672215055915-e6143dc70e6a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwyfHxraGFqdXJhaG8lMjB0ZW1wbGUlMjBhcmNoaXRlY3R1cmV8ZW58MHx8fHwxNzkwOTY4MzQzfDA&ixlib=rb-4.1.0&q=85&w=1400",
  tiger:
    "https://images.unsplash.com/photo-1680140979890-101e2798dddf?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODR8MHwxfHNlYXJjaHwxfHxiYW5kaGF2Z2FyaCUyMHRpZ2VyJTIwbmF0aW9uYWwlMjBwYXJrfGVufDB8fHx8MTc5MDk2ODM0M3ww&ixlib=rb-4.1.0&q=85&w=1400",
  varanasi:
    "https://images.unsplash.com/photo-1766056586808-987b0ab63cdd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHx2YXJhbmFzaSUyMGdhbmdlcyUyMGdoYXR8ZW58MHx8fHwxNzkwOTY4MzQzfDA&ixlib=rb-4.1.0&q=85&w=1400",
  temple:
    "https://images.unsplash.com/photo-1741003411268-2462dd845d26?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxoaW5kdSUyMHRlbXBsZSUyMGluZGlhJTIwcGlsZ3JpbWFnZXxlbnwwfHx8fDE3OTA5NjgzNDN8MA&ixlib=rb-4.1.0&q=85&w=1400",
  templeMP:
    "https://images.pexels.com/photos/11374204/pexels-photo-11374204.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
};

// Responsive on-page copies of the same images. Original URLs above remain
// available for social cards and source attribution.
export const OPTIMIZED_IMAGES = {
  [IMG.heroHighway]: {
    "src": "/images/optimized/hero-highway-1264.webp",
    "width": 2000,
    "height": 1180,
    "srcSet": "/images/optimized/hero-highway-480.webp 480w, /images/optimized/hero-highway-768.webp 768w, /images/optimized/hero-highway-1264.webp 1264w"
  },
  [IMG.outstation]: {
    "src": "/images/optimized/outstation-1264.webp",
    "width": 1400,
    "height": 1867,
    "srcSet": "/images/optimized/outstation-480.webp 480w, /images/optimized/outstation-768.webp 768w, /images/optimized/outstation-1264.webp 1264w"
  },
  [IMG.forestRoad]: {
    "src": "/images/optimized/forest-road-1264.webp",
    "width": 1400,
    "height": 1867,
    "srcSet": "/images/optimized/forest-road-480.webp 480w, /images/optimized/forest-road-768.webp 768w, /images/optimized/forest-road-1264.webp 1264w"
  },
  [IMG.innova]: {
    "src": "/images/optimized/innova-1200.webp",
    "width": 1200,
    "height": 800,
    "srcSet": "/images/optimized/innova-480.webp 480w, /images/optimized/innova-768.webp 768w, /images/optimized/innova-1200.webp 1200w"
  },
  [IMG.tempo]: {
    "src": "/images/optimized/tempo-1264.webp",
    "width": 1264,
    "height": 848,
    "srcSet": "/images/optimized/tempo-480.webp 480w, /images/optimized/tempo-768.webp 768w, /images/optimized/tempo-1264.webp 1264w"
  },
  [IMG.heroFleet]: {
    "src": "/images/optimized/hero-fleet-1264.webp",
    "width": 1264,
    "height": 848,
    "srcSet": "/images/optimized/hero-fleet-480.webp 480w, /images/optimized/hero-fleet-768.webp 768w, /images/optimized/hero-fleet-1264.webp 1264w"
  },
  [IMG.carSedan]: {
    "src": "/images/optimized/car-sedan-1264.webp",
    "width": 1264,
    "height": 848,
    "srcSet": "/images/optimized/car-sedan-480.webp 480w, /images/optimized/car-sedan-768.webp 768w, /images/optimized/car-sedan-1264.webp 1264w"
  },
  [IMG.carSuv]: {
    "src": "/images/optimized/car-suv-1264.webp",
    "width": 1264,
    "height": 848,
    "srcSet": "/images/optimized/car-suv-480.webp 480w, /images/optimized/car-suv-768.webp 768w, /images/optimized/car-suv-1264.webp 1264w"
  },
  [IMG.khajuraho]: {
    "src": "/images/optimized/khajuraho-1264.webp",
    "width": 1400,
    "height": 933,
    "srcSet": "/images/optimized/khajuraho-480.webp 480w, /images/optimized/khajuraho-768.webp 768w, /images/optimized/khajuraho-1264.webp 1264w"
  },
  [IMG.khajuraho2]: {
    "src": "/images/optimized/khajuraho2-1264.webp",
    "width": 1400,
    "height": 2100,
    "srcSet": "/images/optimized/khajuraho2-480.webp 480w, /images/optimized/khajuraho2-768.webp 768w, /images/optimized/khajuraho2-1264.webp 1264w"
  },
  [IMG.tiger]: {
    "src": "/images/optimized/tiger-1264.webp",
    "width": 1400,
    "height": 933,
    "srcSet": "/images/optimized/tiger-480.webp 480w, /images/optimized/tiger-768.webp 768w, /images/optimized/tiger-1264.webp 1264w"
  },
  [IMG.varanasi]: {
    "src": "/images/optimized/varanasi-1264.webp",
    "width": 1400,
    "height": 968,
    "srcSet": "/images/optimized/varanasi-480.webp 480w, /images/optimized/varanasi-768.webp 768w, /images/optimized/varanasi-1264.webp 1264w"
  },
  [IMG.temple]: {
    "src": "/images/optimized/temple-1264.webp",
    "width": 1400,
    "height": 933,
    "srcSet": "/images/optimized/temple-480.webp 480w, /images/optimized/temple-768.webp 768w, /images/optimized/temple-1264.webp 1264w"
  },
  [IMG.templeMP]: {
    "src": "/images/optimized/temple-m-p-1264.webp",
    "width": 2700,
    "height": 1800,
    "srcSet": "/images/optimized/temple-m-p-480.webp 480w, /images/optimized/temple-m-p-768.webp 768w, /images/optimized/temple-m-p-1264.webp 1264w"
  },
  "/logo.png": {
    "src": "/images/optimized/logo-160.webp",
    "width": 512,
    "height": 512,
    "srcSet": "/images/optimized/logo-96.webp 96w, /images/optimized/logo-160.webp 160w, /images/optimized/logo-256.webp 256w, /images/optimized/logo-512.webp 512w"
  },
};
